import { BaseChartDirective } from 'ng2-charts';

export function observeChartResize(host: HTMLElement, getChart: () => BaseChartDirective | undefined): () => void {
  let frame: number | null = null;

  const observer = new ResizeObserver(() => {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = null;
      getChart()?.chart?.resize();
    });
  });

  observer.observe(host);

  return () => {
    if (frame !== null) cancelAnimationFrame(frame);
    observer.disconnect();
  };
}
